import type { CreativeStrategyPackDetail } from '@/services/api';

export function PackGapsPanel({ pack }: { pack: CreativeStrategyPackDetail }) {
  return (
    <div className="max-w-3xl space-y-8">
      <section>
        <h3 className="text-sm font-semibold text-navy-900">Gaps</h3>
        <p className="text-xs text-slate-500 mt-0.5 mb-3">
          Arguments the category runs that this client does not. Opportunities to test, not instructions.
        </p>
        {pack.gaps.length === 0 ? (
          <div className="text-sm text-slate-400">No gaps recorded{pack.client_uid ? ' (client may run no Meta ads)' : ''}.</div>
        ) : (
          <ol className="space-y-1.5">
            {pack.gaps.map((g, i) => (
              <li key={g} className="flex gap-3 text-sm text-slate-800">
                <span className="text-slate-400 tabular-nums w-5 text-right">{i + 1}</span>
                <span>{g}</span>
              </li>
            ))}
          </ol>
        )}
      </section>

      <section>
        <h3 className="text-sm font-semibold text-navy-900">Caveats</h3>
        <p className="text-xs text-slate-500 mt-0.5 mb-3">Carried on every response the platform serves from this docket.</p>
        <ul className="space-y-1.5">
          {pack.caveats.map((c) => (
            <li key={c} className="text-sm text-slate-800 border-l-2 border-amber-300 pl-3">{c}</li>
          ))}
        </ul>
      </section>
    </div>
  );
}
